// import { getEnvironment } from 'config/environment';
import { explanationVideos } from "config/explanation-videos"
import { LetsTalkName } from "components/LetsTalk/types"
import * as React from "react"
import BillionFundedLoans from "components/BillionFundedLoans"
import Document from "components/Document"
import Footer from "components/Footer"
import LearnMore from "components/LearnMore"
import LetsTalk from "components/LetsTalk"
import Media from "components/Media"
import Navbar from "components/Navbar"
import { GetStartedType } from "components/Navbar/GetStartedButton"
import Nerdwallet from "components/Nerdwallet"
import PageWrapper from "components/PageWrapper"
import PriceGuaranteedHomepage from "components/PriceGuaranteedHomepage"
import ReviewsHomepage from "components/ReviewsHomepage"
import SideNav from "components/SideNav"
import SplashHero from "components/SplashHero"
import SplashHeroTypewriter from "components/SplashHeroTypewriter"
import VideoLarge from "components/VideoLarge"

export interface IndexProps {
  showHeroTypewriter?: boolean
}

const Index: React.FC<IndexProps> = ({ showHeroTypewriter }) => {
  const letsTalkButton = {
    text: "Book a free call",
    url: "https://charlie-better.youcanbook.me/",
  }

  return (
    <Document
      pageClass="bet-StaticPage"
      pageId="homepage"
      title="Simple, Online Mortgage"
      keywords="home loans,mortgage interest rates,refinance rates,refinance calculator,refinance mortgage online"
      brandMetaPrefix={true}
    >
      <Navbar
        getStartedType={GetStartedType.ON_SCROLL}
        startTransparent={true}
      />
      <SideNav />
      <PageWrapper>
        <main>
          {showHeroTypewriter ? <SplashHeroTypewriter /> : <SplashHero />}
          <VideoLarge
            id={explanationVideos["who-is-better"].id}
            title={`Why we're Better`}
            isTitleSizeLarge={true}
            subhead="We make home financing affordable. Apply for a mortgage anytime, anywhere, on any device, and we’ll analyze bank and mortgage company data to find you the best rate."
            src={explanationVideos["who-is-better"].directSourceUrl}
            poster={explanationVideos["who-is-better"].poster}
          />

          <PriceGuaranteedHomepage />
          <BillionFundedLoans />
          <LetsTalk
            heading={`Hi, I'm Elizabeth`}
            subhead={`I'm a Mortgage Expert at Better. My team is here to help make getting a mortgage easy. We're available on your schedule over text, email, or phone. Let's talk.`}
            button={letsTalkButton}
            name={LetsTalkName.Elizabeth}
            nmlsCode="1658188"
          />
          <ReviewsHomepage />
          <Nerdwallet />
          <LearnMore />
        </main>
        <Media />
        <Footer />
      </PageWrapper>
    </Document>
  )
}

export default Index
